import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const updateCaseStudy = async ({ id, caseStudyData }) => {
  try {
    const payload = { ...caseStudyData, id };
    const { data } = await axiosInstance.put(`/CaseStudies/${id}`, payload);
    return data;
  } catch (error) {
    console.error("Error updating case study:", error);
    throw error;
  }
};

const useUpdateCaseStudy = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCaseStudy,
    onSuccess: () => {
      queryClient.invalidateQueries(["caseStudies"]);
      queryClient.invalidateQueries(["caseStudy"]);
    },
    onError: (err) => {
      console.error("Update case study mutation failed:", err);
    },
  });
};

export default useUpdateCaseStudy;

